import { render } from "./CardDecretosMunicipais.vue?vue&type=template&id=3483a5c4"
import script from "./CardDecretosMunicipais.vue?vue&type=script&lang=js"
export * from "./CardDecretosMunicipais.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__